import Alert from 'react-s-alert';
import 'react-s-alert/dist/s-alert-default.css';
import 'react-s-alert/dist/s-alert-css-effects/slide.css';

const FailureAlert = (err) => {
    if (err.response && err.response.status !== null && err.response.status !== undefined && err.response.status === 401) {
        Alert.error("Session Expired. Please Login again.", {
            position: 'bottom-right',
            effect: 'slide',
            html: false
        });
    }
    else {
        Alert.error("Application Error. Please try again", {
            position: 'bottom-right',
            effect: 'slide',
            html: false
        });
    }
};

export default FailureAlert;